import React from 'react'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as instructorActions from '../../_actions/roster.actions'
import * as leaveActions from '../../_actions/employeeLeave.actions'
import _ from 'lodash'
import BigCalendar from 'react-big-calendar'
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop'
// import 'react-big-calendar/lib/css/react-big-calendar.css'
// import 'react-big-calendar/lib/addons/dragAndDrop/styles.css'

// import ETimeForm from '../etimeform/ETimeForm'
import LeaveDetails from '../etimeform/LeaveDetails'
// react-bootstrap modal
import { Menubar } from 'primereact/menubar'
import { Button } from 'primereact/button'
import DraggableModalDialog from '../common/DraggableModalDialog'

// import { Modal } from 'antd';
// import Modal from 'react-bootstrap/Modal'
import { DndProvider } from 'react-dnd'
import TimeUtils from '../../utils/TimeUtils'
import { Dialog } from 'primereact/dialog'
import EmpView from './EmpView'
import ActionConfig from './actionConfig'
import ToolBar from './Toolbar'
// import ToolBar from './WorkToolbar'
import { denormalize, schema } from 'normalizr'
import { eventSchema } from './../../entities/schema'
import Cost from '../styled-component/StyledCost'
import { toast } from 'react-toastify'
import {
    Popover,
    Select,
    Collapse,
    Calendar,
    Card,
    DatePicker,
    Modal,
} from 'antd'
import dayjs from 'dayjs'
import WorkViewRoster from './WorkViewRoster'
import ColorCustomization from '../settings/theme/ColorCustomization'

import ManagerApproval from './ManagerApproval'
import RosterManagment from './RosterManagment'
import RosterTemplate from './RosterTemplate'
import Moment from 'moment'
import { extendMoment } from 'moment-range'

import { viewConstants } from '../../_constants/view.constants'

import './css/style.css'

import 'react-big-calendar/lib/addons/dragAndDrop/styles.css'
// import "react-big-calendar/lib/css/react-big-calendar.css";

toast.configure()

// const moment = require('moment')
const moment = extendMoment(Moment)
const localizer = BigCalendar.momentLocalizer(moment)
const DragAndDropCalendar = withDragAndDrop(BigCalendar, DndProvider)

const WHOLE_DAY = 86400000

const NORMALWORKING_ACTION = 99

const ActionTypes = {
    NORMAL_WORKING: NORMALWORKING_ACTION,
    ANNUAL_LEAVE: 1,
    SICK_LEAVE: 2,
    ALTERNATIVE_LEAVE: 3,
    BEREAVEMENT_LEAVE: 4,
    LONGSERVICE_LEAVE: 5,
    SPECIAL_SERVICE_LEAVE: 6,
    DOMESTIC_LEAVE: 7,
    OTHER_PAID_LEAVE: 8,
    UNPAID_LEAVE: 9,
    OVERTIME_LIEU_LEAVE: 10,
    STUDY_LEAVE: 11,
    BIRTHDAY_LEAVE: 12,
    PARENTAL_LEAVE: 13,
}

const { Panel } = Collapse

class Rostering extends React.PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            currentMonth: new Date(),
            selectedDate: new Date(),
            showModal: false,
            event: {},
            events: [],
            employees: [],
            displayEvents: [],
            displayEmployees: [],
            showForm: false,
            formTitle: '',
            activeTab: '1',
            selectedBranch: {},
            selectedDepartment: {},
            mounted: false,
            showLegend: false,
            clicked: false,
            hovered: false,
            content: 'roster',
            openFilterDrawer: false,
            modalActionType: '',
        }

        this.target = React.createRef()
    }

    componentDidMount() {
        const { events, selectedEmployee, branches, departments } = this.props
        // if (events != undefined && events.length == 0) {
        //     this.props.actions.fetchUserETime()
        // }

        if (!_.isEmpty(selectedEmployee)) {
            const filteredEvents = _.filter(events, function(evt) {
                return evt.EmployeeID === selectedEmployee
            })

            this.setState({
                displayEvents: filteredEvents,
            })
        }

        this.setState({ mounted: true })
    }

    hide = () => {
        this.setState({
            clicked: false,
            hovered: false,
        })
    }

    handleHoverChange = visible => {
        this.setState({
            hovered: visible,
            clicked: false,
        })
    }

    handleClickChange = visible => {
        this.setState({
            clicked: visible,
            hovered: false,
        })
    }

    resetEvents = (currentEmployee, filteredEmployees) => {
        const selected = _.find(filteredEmployees, {
            EmployeeID: currentEmployee,
        })

        if (_.isEmpty(selected)) {
            this.props.actions.selectEmployee('')
            this.setState({ displayEvents: [] })
        }
    }

    filterEvents = employeeID => {
        const { events } = this.props
        const filteredEvents = _.filter(events, function(evt) {
            return evt.EmployeeID === employeeID
        })

        this.setState({
            displayEvents: filteredEvents,
        })
    }

    onFormHide = () => {
        this.setState({ modalActionType: '' })
    }

    // handleShow = () => {
    //     this.setState({ showForm: true })
    // }

    moveEvent = ({ event, start, end, isAllDay: droppedOnAllDaySlot }) => {
        let allDay = event.allDay

        if (event.source === 'timesheet') {
            toast.warning('Read only event!', {
                position: 'top-center',
                // autoClose: 30000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            })
            return
        }

        if (!event.allDay && droppedOnAllDaySlot) {
            allDay = true
        } else if (event.allDay && !droppedOnAllDaySlot) {
            allDay = false
        }

        const updatedEvent = { ...event, start, end, allDay }

        this.props.actions.updateEvent(
            updatedEvent,
            this.props.selectedEmployee
        )
    }

    extendEvent = (event, start, end, sameStart) => {
        const newStartTime = TimeUtils.extractTime(event.start)
        const newEndTime = TimeUtils.extractTime(event.end)

        const minStart = moment.min([moment(start), moment(event.start)])
        const maxEnd = moment.max([moment(end), moment(event.end)])

        const adjustedMaxEnd = sameStart ? maxEnd.subtract(1, 'days') : maxEnd

        const eventStart = moment(TimeUtils.extractDate(minStart))

        let day = eventStart
        const cloneEvent = _.clone(event)

        if (sameStart) {
            cloneEvent.start = moment(
                TimeUtils.combineDateNTime(day.clone(), newStartTime)
            ).add(1, 'days')
            cloneEvent.end = moment(
                TimeUtils.combineDateNTime(adjustedMaxEnd, newEndTime)
            )
        } else {
            cloneEvent.start = moment(
                TimeUtils.combineDateNTime(day.clone(), newStartTime)
            )
            cloneEvent.end = moment(
                TimeUtils.combineDateNTime(adjustedMaxEnd, newEndTime)
            ).subtract(1, 'day')
        }

        delete cloneEvent.id
        this.props.actions.addEvent(cloneEvent, this.props.selectedEmployee)
    }

    // resize roster, generate copy of the same event
    copyEvent = ({ event, start, end }) => {
        // const range = moment.range(start, end);

        // const rangeByDay = Array.from(range.by("day"));

        let data = {}
        data.id = event.id
        data.start = start
        data.end = end

        this.props.actions.copyInsertEvents(data)
    }

    resizeEvent = ({ event, start, end }) => {
        // sameday: if start equal event.start && end == 24 hours from start

        const { events } = this.props

        const duration = moment(end).diff(start) == WHOLE_DAY // 24 hours
        const sameStart = moment(start).isSame(event.start)
        const sameEnd = moment(end).isSame(event.end)
        const orgDuration = moment(event.end).diff(event.start) > WHOLE_DAY
        const sameDayEvent =
            moment(event.end).diff(event.start) < WHOLE_DAY &&
            moment(TimeUtils.extractDate(event.end)).isSame(
                TimeUtils.extractDate(event.start)
            )

        const nextEvents = _.find(events, { id: event.id })

        // same day event
        if (sameDayEvent) {
            // repeatable event, expand to multiple days
            let period = 0
            if (sameStart) {
                period = moment(end).diff(event.start, 'days')
            } else if (sameEnd) {
                period = moment(event.end).diff(start, 'days')
            } else {
                period = moment(end).diff(start, 'days')
            }

            const multiple = period > 0

            if (multiple) {
                // repeat same event
                this.extendEvent(nextEvents, start, end, sameStart, sameEnd)
            } else {
                // within same day
                const newStartDate = TimeUtils.extractDate(start)
                const newStartTime = TimeUtils.extractTime(start)
                const newStart = TimeUtils.combineDateNTime(
                    newStartDate,
                    newStartTime
                )

                const newEndDate = TimeUtils.extractDate(end)
                const newEndTime = TimeUtils.extractTime(end)
                const newEnd = TimeUtils.combineDateNTime(
                    newEndDate,
                    newEndTime
                )

                nextEvents.start = moment(newStart)
                nextEvents.end = moment(newEnd)
                nextEvents.allDay = false
                this.props.actions.updateEvent(
                    nextEvents,
                    this.props.selectedEmployee
                )
            }
        }

        // whole period event, not repeatable
        if (!sameDayEvent) {
            // resize to the one day
            if (duration && (sameStart || sameEnd) && orgDuration) {
                const newEvtDate = sameStart
                    ? TimeUtils.extractDate(start)
                    : TimeUtils.extractDate(end)

                const sTime = TimeUtils.extractTime(event.start)
                const newStartDate = TimeUtils.combineDateNTime(
                    newEvtDate,
                    sTime
                )

                const eTime = TimeUtils.extractTime(event.end)
                const newEndDate = TimeUtils.combineDateNTime(newEvtDate, eTime)

                nextEvents.start = moment(newStartDate)
                nextEvents.end = moment(newEndDate)
                nextEvents.allDay = false
            } else {
                // extend to multiple days
                const overOneDay = moment(end).diff(event.start) > WHOLE_DAY

                if (overOneDay) {
                    const newStartDate = TimeUtils.extractDate(start)
                    const newStartTime = TimeUtils.extractTime(event.start)
                    const newStart = TimeUtils.combineDateNTime(
                        newStartDate,
                        newStartTime
                    )

                    // expand over one day event, same start, then -1 day
                    const oneDay = moment.duration(1, 'd')
                    const newEndDate = sameStart
                        ? TimeUtils.extractDate(moment(end).subtract(oneDay))
                        : TimeUtils.extractDate(end)
                    const newEndTime = TimeUtils.extractTime(event.end)
                    const newEnd = TimeUtils.combineDateNTime(
                        newEndDate,
                        newEndTime
                    )

                    nextEvents.start = moment(newStart)
                    nextEvents.end = moment(newEnd)
                    nextEvents.allDay = false
                } else {
                    // within same day
                    const newStartDate = TimeUtils.extractDate(start)
                    const newStartTime = TimeUtils.extractTime(start)
                    const newStart = TimeUtils.combineDateNTime(
                        newStartDate,
                        newStartTime
                    )

                    const newEndDate = TimeUtils.extractDate(end)
                    const newEndTime = TimeUtils.extractTime(end)
                    const newEnd = TimeUtils.combineDateNTime(
                        newEndDate,
                        newEndTime
                    )

                    nextEvents.start = moment(newStart)
                    nextEvents.end = moment(newEnd)
                    nextEvents.allDay = false
                }
            }
            this.props.actions.updateEvent(
                nextEvents,
                this.props.selectedEmployee
            )
        }
    }

    handleSelectSlot = e => {
        if (!_.isEmpty(this.props.selectedEmployees)) {
            this.newEvent(e)
        }
        // if (
        //     moment(start).isSameOrAfter(today, 'day') &&
        //     !_.isEmpty(this.props.selectedEmployees)
        // ) {
        //     this.newEvent(e)
        // }
    }
    disableSelect = e => {}
    newEvent = event => {
        let eTimeRequest = {
            id: '',
            title: '',
            actionType: {
                label: 'Normal working',
                value: NORMALWORKING_ACTION,
            },
            allDay: event.slots.length == 1,
            dateFrom: event.start,
            dateTo: event.slots.length > 1 ? event.end : undefined,
            draggable: true,
            status: 0,
            startTime: '09:00',
            endTime: '17:30',
            duration: '',
            break: event.break || '0',
            note: '',
            existing: false,
        }

        // fetch employee default work pattern
        const employeeNormalWorkHours = this.props.payrollNormalWorkHour[
            this.props.selectedEmployee
        ]

        if (!_.isEmpty(employeeNormalWorkHours)) {
            // year, month, date
            const evtYear = moment(event.start).year()
            const evtMonth = moment(event.start).month()
            const evtDate = moment(event.start).date()

            // local weekday
            const weekday = moment(event.start).weekday() + 1

            //PayrollEmpNormalWorkingHourStartTimeHour,PayrollEmpNormalWorkingHourStartTimeMinute

            const startTimeHour =
                employeeNormalWorkHours[
                    `PayrollEmpNormalWorkingHourStartTimeHour${weekday}`
                ]
            const startTimeMinute =
                employeeNormalWorkHours[
                    `PayrollEmpNormalWorkingHourStartTimeMinute${weekday}`
                ]

            //[PayrollEmpNormalWorkingHourFinishTimeHour],[PayrollEmpNormalWorkingHourFinishTimeMinute1]
            const finishTimeHour =
                employeeNormalWorkHours[
                    `PayrollEmpNormalWorkingHourFinishTimeHour${weekday}`
                ]
            const finishTimeMinute =
                employeeNormalWorkHours[
                    `PayrollEmpNormalWorkingHourFinishTimeMinute${weekday}`
                ]
            //[PayrollEmpNormalWorkingHourBreakMinute]
            const breakMinute =
                employeeNormalWorkHours[
                    `PayrollEmpNormalWorkingHourBreakMinute${weekday}`
                ]

            // reset the start, end time
            //[year, month, day, hour, minute, second, millisecond]
            const evtStartTime = moment([
                evtYear,
                evtMonth,
                evtDate,
                startTimeHour,
                startTimeMinute,
            ])
            const evtFinishTime = moment([
                evtYear,
                evtMonth,
                evtDate,
                finishTimeHour,
                finishTimeMinute,
            ])

            // eTimeRequest
            eTimeRequest.startTime = TimeUtils.extractTime(
                evtStartTime.toDate()
            )
            eTimeRequest.endTime = TimeUtils.extractTime(evtFinishTime.toDate())
            eTimeRequest.break = breakMinute
        }

        this.setState({ event: eTimeRequest })
        this.setState({ modalActionType: 'leave' })
        // const { selectedEmployee } = this.props;
        // this.filterEvents(selectedEmployee)
    }

    customColorEventPropGetter = event => {
        // Get base color based on leave type
        let baseColor = '#0a75ad' // default color

        if (event.Status) {
            baseColor = '#C8C6C6'
        } else {
            switch (event.PayrollEmpLeaveTypeID) {
                case 1:
                    baseColor = '#065535'
                    break
                case 2:
                    baseColor = '#000000'
                    break
                case 3:
                    baseColor = '#133337'
                    break
                case 4:
                    baseColor = '#d1477a'
                    break
                case 5:
                    baseColor = '#b8860b'
                    break
                case 6:
                    baseColor = '#e6940a'
                    break
                case 7:
                    baseColor = '#0000ff'
                    break
                case 8:
                    baseColor = '#cd5c5c'
                    break
                case 9:
                    baseColor = '#7ba428'
                    break
                case 10:
                    baseColor = '#4682b4'
                    break
                case 11:
                    baseColor = '#666666'
                    break
                case 12:
                    baseColor = '#7ba428'
                    break
                case 13:
                    baseColor = '#cd5c5c'
                    break
                case 14:
                    baseColor = '#708090'
                    break
                case 19:
                    baseColor = '#800080'
                    break
                case 20:
                    baseColor = '#800000'
                    break
                default:
                    baseColor = '#0a75ad'
                    break
            }
        }

        // Apply approval status styling
        if (event.approved === false || event.approved === 0) {
            // Non-approved events: striped pattern or dashed border
            return {
                style: {
                    backgroundColor: baseColor,
                    opacity: 0.6,
                    border: '2px dashed #ff4d4f',
                    borderRadius: '4px',
                    backgroundImage: `repeating-linear-gradient(
                        45deg,
                        transparent,
                        transparent 2px,
                        rgba(255,255,255,0.3) 2px,
                        rgba(255,255,255,0.3) 4px
                    )`,
                },
            }
        } else if (event.approved === true || event.approved === 1) {
            // Approved events: solid color with green checkmark indicator
            return {
                style: {
                    backgroundColor: baseColor,
                    border: '2px solid #52c41a',
                    borderRadius: '4px',
                    position: 'relative',
                },
            }
        } else {
            // Pending or unknown status: default styling
            return {
                style: {
                    backgroundColor: baseColor,
                    border: '2px solid #faad14',
                    borderRadius: '4px',
                    opacity: 0.8,
                },
            }
        }
    }

    renderEvetDetail = event => {
        let eTimeRequest = {
            id: event.id,
            title: event.Title || event.title,
            actionType: event.ActionType,
            allDay: event.allDay,
            dateFrom: event.start,
            dateTo: event.end,
            startTime: TimeUtils.extractTime(event.start),
            endTime: TimeUtils.extractTime(event.end),
            duration: event.ActionHours || '',
            break: event.Break || 0,
            Note: event.Note || '',
            existing: true,
            approved: event.approved,
            employeeID: event.EmployeeID,
            hours: event.hours || 0,
            source: event.source,
        }

        this.setState({ event: eTimeRequest })
        this.setState({ modalActionType: 'leave' })
    }

    removeEvent = event => {
        this.props.actions
            .removeEventById(this.state.event.id)
            .then(res =>
                _.head(document.getElementsByClassName('close')).click()
            )
            .catch(error => {
                console.log(`error=${error}`)
            })
    }

    handleSelect = employeeId => {
        this.setState({ currentEmployee: employeeId })
        this.filterEvents(employeeId)
    }

    filterDisplayEvents = () => {
        let displayEvents = []
        if (this.props.displayEvents !== undefined) {
            displayEvents = _.map(
                this.props.displayEvents,

                (obj, key) => {
                    return obj
                }
            )
            return displayEvents
        }
        return displayEvents
    }

    handleModalShow = () => {
        this.setState({ showLegend: true })
    }

    handleModalClose = () => {
        this.setState({ showLegend: false })
    }

    refreshTable = () => {
        window.location.reload(false)
    }

    onLegendHide = name => {
        this.setState({ showLegend: false })
    }

    onShowMore = () => {
        window.alert('show more')
    }

    render() {
        const items = [
            // {
            //     label: 'Roster management',
            //     icon: 'pi pi-fw pi-user-edit',
            //     command: () => this.setState({ content: 'manager' }),
            // },
            {
                label: 'View',
                icon: 'pi pi-fw pi-eye',
                items: [
                    {
                        label: 'Week',
                        command: () => {
                            this.setState({ content: 'weekly' })
                            const options = {
                                range: viewConstants.WEEK,
                                time: new Date(),
                            }

                            this.props.actions.leaveActions.fetchEmployeeLeave(
                                options
                            )
                        },
                    },
                    {
                        separator: true,
                    },
                    {
                        label: 'Calendar',
                        command: () => {
                            this.setState({ content: 'roster' })

                            const options = {
                                range: viewConstants.MONTH,
                                time: this.props.currentDate || new Date(),
                            }

                            this.props.actions.leaveActions.fetchEmployeeLeave(
                                options
                            )
                        },
                    },
                ],
            },
        ]
        let components = {
            toolbar: ToolBar,
        }

        const legend = (
            <div>
                <ColorCustomization />
            </div>
        )

        const end = (
            <div>
                <Popover
                    style={{ maxWidth: '400px' }}
                    content={legend}
                    trigger="hover"
                    open={this.state.hovered}
                    onOpenChange={this.handleHoverChange}
                >
                    <Button
                        label="Legend"
                        className="p-button-raised p-button-info p-button-text"
                    />
                </Popover>
            </div>
        )

        // const onChange = (date, dateString) => {
        //     // console.log(date)
        //     this.setState({ selectedDate: date.toDate() })
        // }

        // const onPanelChange = (value, mode) => {
        //     console.log(value.format('YYYY-MM-DD'), mode)
        // }

        const rosterContent = (
            <div className="row">
                <div className="col-md-2 col-lg-2">
                    <div className="panel">
                        {/* <div className="panel-heading">
                            <p className="panel-title">Filter</p>
                        </div> */}

                        <div className="panel-body sidegroup">
                            <EmpView
                                filterEvents={this.filterEvents.bind(this)}
                                resetEvents={this.resetEvents.bind(this)}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-md-10">
                    <div className="panel">
                        <div className="panel-body">
                            <div></div>
                            <div className="calendar">
                                <div className="roster m-2">
                                    <DragAndDropCalendar
                                        popup={true}
                                        selectable
                                        localizer={localizer}
                                        events={this.filterDisplayEvents()}
                                        //onEventDrop={this.moveEvent}
                                        resizable
                                        //onEventResize={this.copyEvent}
                                        onSelectEvent={this.renderEvetDetail}
                                        // onSelectSlot={
                                        //     _.isEmpty(
                                        //         this.props.selectedEmployees
                                        //     )
                                        //         ? this.disableSelect
                                        //         : this.newEvent
                                        // }
                                        // onSelectSlot={this.handleSelectSlot}
                                        views={['month']}
                                        defaultView={BigCalendar.Views.MONTH}
                                        defaultDate={this.props.currentDate}
                                        // date={this.state.selectedDate}
                                        eventPropGetter={
                                            this.customColorEventPropGetter
                                        }
                                        dayPropGetter={this.customDayPropGetter}
                                        titleAccessor="Title"
                                        startAccessor="start"
                                        endAccessor="end"
                                        showMultiDayTimes={true}
                                        draggableAccessor="draggable"
                                        culture="en-NZ"
                                        tooltipAccessor="Title"
                                        classNameCustom="rbc-calendar"
                                        // employees={this.props.employees}
                                        components={components}
                                        // onShowMore={this.onShowMore}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

        // const manager = <RosterManagment />
        const approval = <ManagerApproval />
        const template = <RosterTemplate />

        const weeklyView = <WorkViewRoster actions={this.props.actions} />

        const endElement = <div></div>

        const { content } = this.state
        return (
            <div className="">
                <div className="row">
                    <div className="col-sm-12 col-md-12">
                        <Menubar model={items} end={endElement} />
                    </div>
                </div>
                {content === 'roster' && rosterContent}
                {/* {content === 'manager' && manager} */}
                {/* {content === 'approval' && approval} */}
                {content === 'template' && template}
                {content === 'weekly' && weeklyView}
                <div>
                    <Dialog
                        header="Color"
                        visible={this.state.showLegend}
                        // style={{ width: '50vw' }}
                        // footer={renderFooter('displayBasic')}
                        onHide={() => this.onLegendHide('displayBasic')}
                        maximized={false}
                        maximizable={true}
                    >
                        <ColorCustomization />
                    </Dialog>
                </div>

                <Dialog
                    header="Leave"
                    visible={this.state.modalActionType === 'leave'}
                    // footer={renderFooter('displayBasic')}
                    onHide={this.onFormHide}
                    maximized={false}
                    maximizable={false}
                    resizable={true}
                    breakpoints={{ '960px': '75vw', '640px': '100vw' }}
                    style={{ width: '50vw' }}
                >
                    <LeaveDetails
                        event={this.state.event}
                        renderContent="roster"
                        selectedEmployees={this.props.selectedEmployees}
                        actionTypes={
                            this.props.readOnly
                                ? _.slice(this.props.actionTypes, 1)
                                : this.props.actionTypes
                        }
                        showEmployee={true}
                        disableEmployeeSelection={true}
                        onHide={this.onFormHide}
                        readOnly={true}
                    />
                </Dialog>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        currentDate: state.roster.currentDate,
        events: state.employeeLeave.leaves,
        displayEvents: state.employeeLeave.displayLeaves,
        displayEmployees: state.roster.displayEmployees,
        selectedEmployee: state.roster.selectedEmployee,
        selectedEmployees: state.roster.selectedEmployees,
        branches: state.BranchReducer.branchList,
        departments: state.DepartmentReducer.departmentList,
        actionTypes: state.ActionTypesReducer.actionTypes,
        payrollDefaultWorkHour: state.payrollDefaultWorkHour,
        payrollNormalWorkHour: state.payrollNormalWorkHour,
        colors: state.colors.colors,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            rosterActions: bindActionCreators(instructorActions, dispatch),
            leaveActions: bindActionCreators(leaveActions, dispatch),
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Rostering)

// export default Rostering
